import { FC, memo } from 'react'

import dynamic from 'next/dynamic'

const Popup = dynamic(() => import('./Popup'), {
  ssr: false,
})

type Props = any & {
  children: JSX.Element
}

const AbstractPopup: FC<Props> = ({ children, ...props }) => {
  return <Popup {...props}>{children}</Popup>
}

export default memo(AbstractPopup)
